import {api} from "@/shared/api";

import {ProjectTimeTimelineDay} from "../projecttime/projectTimeTimelineDay";
import {CombinedTimelineDayComponentConfig, ProjectTimeTimelineDayContent, WorkingTimeTimelineDayContent} from "../timelineTypes";
import {CombinedTimelineDay} from "../combined/combinedTimelineDay";
import {getCurrentISOOffset, Temporal} from "@/shared/utils/datefunctions";
import {CombinedRecordingStatus} from "@/shared/timr";
import {closeOpenTimelineContextMenus, TimelineContextMenu} from "../timelineContextMenu";
const template = `
			<!-- loading skeleton -->
			<div class="loading-timeline" style="display: none">
				<div class="mb-50">
					<combined-timeline-day-title class="pb-5">
						<span class="text-loading"></span>
						<div class="title-statistics-container">
							<div class="title-statistics">
								<span class="text-loading"></span>
								<span class="text-loading"></span>
								<span class="text-loading"></span>
							</div>
							<span class="text-loading text-block mr-5"></span>
						</div>
					</combined-timeline-day-title>
					<div class="timeline-day">
						<combined-timeline-day-items class="timeline-items">
							<div class="item-working-time">
								<span class="times subitem-start">
									<span class="text-loading text-block"></span>
									<span class="text-loading text-block"></span>
								</span>
								<div class="panel border-color border-loading">
									<div class="panel-heading">
										<div class="item-working-time-type text-loading-light"></div>
										<div class="text-loading-light"></div>
									</div>
									<div class="panel-body">
										<div class="subitems">
											<div class="subitem-project-time">
												<div class="times">
													<span class="text-loading text-block"></span>
													<span class="text-loading text-block"></span>
												</div>
												<div class="subitem-project-time-content">
													<div class="subitem-project-time-task text-loading-light"></div>
													<div class="text-loading-light text-block"></div>
												</div>
											</div>
											<div class="subitem-project-time">
												<div class="times">
													<span class="text-loading text-block"></span>
													<span class="text-loading text-block"></span>
												</div>
												<div class="subitem-project-time-content">
													<div class="subitem-project-time-task text-loading-light"></div>
													<div class="text-loading-light text-block"></div>
												</div>
											</div>
											<div class="subitem-project-time">
												<div class="times times-no-start">
													<span class="text-loading text-block"></span>
													<span class="text-loading text-block"></span>
												</div>
												<div class="subitem-project-time-content">
													<div class="subitem-project-time-task text-loading-light"></div>
													<div class="text-loading-light text-block"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="item-gap">
								<div class="panel panel-gap">
									<span class="text-loading-light text-block ml-10"></span>
									<span class="text-loading-light text-block mr-5"></span>
								</div>
							</div>
							<div class="item-working-time">
								<span class="times">
									<span class="text-loading text-block"></span>
									<span class="text-loading text-block"></span>
								</span>
								<div class="panel border-color border-loading">
									<div class="panel-heading">
										<div class="item-working-time-type text-loading-light"></div>
										<div class="text-loading-light text-block"></div>
									</div>
								</div>
							</div>
						</combined-timeline-day-items>
					</div>
				</div>
				<div class="mb-50">
					<div class="timeline-title pb-5">
						<span class="text-loading"></span>
						<div class="title-statistics-container">
							<div class="title-statistics">
								<span class="text-loading"></span>
								<span class="text-loading"></span>
								<span class="text-loading"></span>
							</div>
							<span class="text-loading text-block mr-5"></span>
						</div>
					</div>
					<div class="timeline-day">
						<div class="timeline-holiday">
							<div class="text-loading"></div>
						</div>
					</div>
				</div>
				<div class="mb-50">
					<div class="timeline-title pb-5">
						<span class="text-loading"></span>
						<div class="title-statistics-container">
							<div class="title-statistics">
								<span class="text-loading"></span>
								<span class="text-loading"></span>
								<span class="text-loading"></span>
							</div>
							<span class="text-loading text-block mr-5"></span>
						</div>
					</div>
					<div class="timeline-day">
						<div class="timeline-items">
							<div class="item-working-time">
								<span class="times subitem-start subitem-end">
									<span class="text-loading text-block"></span>
									<span class="text-loading text-block"></span>
								</span>
								<div class="panel border-color border-loading">
									<div class="panel-heading">
										<div class="item-working-time-type text-loading-light"></div>
										<div class="text-loading-light text-block"></div>
									</div>
									<div class="panel-body">
										<div class="subitems">
											<div class="subitem-project-time">
												<div class="times">
													<span class="text-loading text-block"></span>
													<span class="text-loading text-block"></span>
												</div>
												<div class="subitem-project-time-content">
													<div class="subitem-project-time-task text-loading-light"></div>
													<div class="text-loading-light text-block"></div>
												</div>
											</div>
											<div class="subitem-project-time">
												<div class="times times-no-start">
													<span class="text-loading text-block"></span>
													<span class="text-loading text-block"></span>
												</div>
												<div class="subitem-project-time-content">
													<div class="subitem-project-time-task text-loading-light"></div>
													<div class="text-loading-light text-block"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- timeline container -->
			<div data-timeline-days></div>

			<!-- shared timeline context menu -->
			<div id="${TimelineContextMenu.HOST_ID}" class="context-table-row"></div>
`;

/**
 * Abstract base class for a view displaying timeline days.
 * This class provides common functionality for timeline views that display timeline days, such as populating the timeline with days,
 * handling loading states, and managing the combined recording status.
 * Have a look at <code>WorkingTimeTimelineView</code> and <code>ProjectTimeTimelineView</code> for implementations.
 * For an overview of the timeline architecture, have a look into the UML diagram "timeline_web_components.png"
 */
export abstract class BaseTimelineView extends HTMLElement {
	private static readonly PAGE_CONTENT_CLICK_NAMESPACE = ".timelineContextMenuClose";

	private readonly _timelineDayComponents: Array<CombinedTimelineDay | ProjectTimeTimelineDay> = [];
	private _config: CombinedTimelineDayComponentConfig;
	private _combinedRecordingStatus: CombinedRecordingStatus;
	private _cachedCombinedRecordingStatus: CombinedRecordingStatus;
	private _timelineRequest: JQueryXHR;
	private _userId: number = globals.userId;

	public abstract load(userId: number, date: Temporal.PlainDate): void

	public abstract reload(): void;

	public connectedCallback(): void {
		this.innerHTML = template;

		// register a global click handler to close any open timeline context menu
		$(document.body).off(`click${BaseTimelineView.PAGE_CONTENT_CLICK_NAMESPACE}`);
		$(document.body).on(`click${BaseTimelineView.PAGE_CONTENT_CLICK_NAMESPACE}`, (event) => {
			if (event.target.closest("[data-context-menu-button]")) {
				return;
			}

			closeOpenTimelineContextMenus();
		});
	}

	public disconnectedCallback(): void {
		$(document.body).off(`click${BaseTimelineView.PAGE_CONTENT_CLICK_NAMESPACE}`);
	}

	/**
	 * Populates the timeline with the provided working time and project time timeline days.
	 * It first clears any existing timeline days, then sets the combined recording status,
	 * and finally updates the timeline days based on the provided data.
	 * @param workingTimeTimelineDays
	 * @param projectTimeTimelineDays
	 * @param combinedRecordingStatus
	 * @param updateCache - If true, the cached combined recording status will be updated with the provided status.
	 * @protected
	 */
	protected populateTimeline(
		workingTimeTimelineDays: WorkingTimeTimelineDayContent[] | null,
		projectTimeTimelineDays: ProjectTimeTimelineDayContent[] | null,
		combinedRecordingStatus: CombinedRecordingStatus,
		updateCache: boolean
	): void {
		this.clearTimelineDays();

		this.combinedRecordingStatus = combinedRecordingStatus;

		/* This cache allows the component to remember the last known recording status, which can be useful for restoring UI state or avoiding unnecessary data fetches.
		 * The conditional ensures the cache is updated only when explicitly requested, preventing unwanted overwrites. It is used in timeline pages which handle reloads.
		 */
		if (updateCache) {
			this.cachedCombinedRecordingStatus = combinedRecordingStatus;
		}

		this.updateTimelineDays(workingTimeTimelineDays, projectTimeTimelineDays);
	}

	/**
	 * Updates the timeline days by appending the created day components to the timeline.
	 * Depending on the provided arguments, it processes either project time timeline days or working time timeline days.
	 * If project time timeline days are provided (project time available, working time not), it creates and appends <code>ProjectTimeTimelineDay</code> components.
	 * Otherwise, if working time timeline days are provided (working time available), it creates and appends <code>CombinedTimelineDay</code> components.
	 *
	 * @param {WorkingTimeTimelineDayContent[] | null} workingTimeTimelineDays - An array of working time timeline days to process, or null if not applicable.
	 * @param {ProjectTimeTimelineDayContent[] | null} projectTimeTimelineDays - An array of project time timeline days to process, or null if not applicable.
	 * @param {boolean} reverse - If true, the order of the days will be reversed during transformation (order needs to be reversed to have the latest day on top (if multiple days are displayed in daily view)
	 * @return {void} This method does not return a value.
	 */
	protected updateTimelineDays(workingTimeTimelineDays: WorkingTimeTimelineDayContent[] | null, projectTimeTimelineDays: ProjectTimeTimelineDayContent[] | null): void {
		if (projectTimeTimelineDays !== null) {
			this.appendTimelineDays(projectTimeTimelineDays, () => document.createElement("project-time-timeline-day") as ProjectTimeTimelineDay);
			return;
		}

		if (workingTimeTimelineDays !== null) {
			this.appendTimelineDays(workingTimeTimelineDays, () => document.createElement("combined-timeline-day") as CombinedTimelineDay);
		}
	}

	private appendTimelineDays(days: Array<WorkingTimeTimelineDayContent | ProjectTimeTimelineDayContent>, createComponent: () => CombinedTimelineDay | ProjectTimeTimelineDay): void {
		const container = this.querySelector(`div[data-timeline-days]`);
		for (const timelineDay of days) {
			const component: CombinedTimelineDay | ProjectTimeTimelineDay = createComponent();
			component.timelineDay = timelineDay;
			component.config = this.config;
			component.combinedRecordingStatus = this.combinedRecordingStatus;

			container.append(component);
			this._timelineDayComponents.push(component);
		}
	}

	protected requestTimelineEntries(endpoint: string, params: Record<string, string>, showLoadingSkeleton = false): JQueryXHR {
		this._timelineRequest?.abort();
		if (showLoadingSkeleton) {
			this.toggleLoadingSkeleton(true);
		}
		this._timelineRequest = api(endpoint)
			.get({
				localTimeZone: getCurrentISOOffset(),
				userId: this.userId,
				...params
			})
			.always(() => {
				if (showLoadingSkeleton) {
					this.toggleLoadingSkeleton(false);
				}
			});
		return this._timelineRequest;
	}

	private toggleLoadingSkeleton(showLoading: boolean): void {
		const loadingTimeline: HTMLDivElement = this.querySelector(".loading-timeline");
		if (loadingTimeline) {
			loadingTimeline.style.display = showLoading ? "block" : "none";
		}

		const container: HTMLElement = this.querySelector(`div[data-timeline-days]`);
		if (container) {
			this.setTimelineContainerVisibility(container, showLoading);
		}
	}

	private setTimelineContainerVisibility(container: HTMLElement, showLoading: boolean): void {
		container.style.visibility = showLoading ? "hidden" : "visible";
	}

	private clearTimelineDays(): void {
		this._timelineDayComponents.length = 0;
		this.querySelector(`div[data-timeline-days]`).innerHTML = "";
	}

	protected get timelineDaysContainer(): HTMLDivElement {
		return this.querySelector(`div[data-timeline-days]`);
	}

	protected get timelineDayComponents(): ReadonlyArray<CombinedTimelineDay | ProjectTimeTimelineDay> {
		return this._timelineDayComponents;
	}

	get config(): CombinedTimelineDayComponentConfig {
		return this._config;
	}

	set config(value: CombinedTimelineDayComponentConfig) {
		this._config = value;
	}

	get combinedRecordingStatus(): CombinedRecordingStatus {
		return this._combinedRecordingStatus;
	}

	set combinedRecordingStatus(value: CombinedRecordingStatus) {
		this._combinedRecordingStatus = value;

		for (const component of this._timelineDayComponents) {
			component.combinedRecordingStatus = value;
		}
	}

	get cachedCombinedRecordingStatus(): CombinedRecordingStatus {
		return this._cachedCombinedRecordingStatus;
	}

	set cachedCombinedRecordingStatus(value: CombinedRecordingStatus) {
		this._cachedCombinedRecordingStatus = value;
	}

	get userId(): number {
		return this._userId;
	}

	set userId(value: number) {
		this._userId = value;
	}
}
